import React from 'react'

function MobileLogo() {
  return (
    <a href="/" className="logo lg:w-[15%] md:w-4/12 sm:w-[20%]">
    <img
      src="/SB9 5.svg"
      alt="sbd logo"
      className="md:hidden inline-block"
      width={40}
      height={40}
    />
  </a>
  )
}

export default MobileLogo
